<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
      <form [formGroup]="deviceForm" novalidate>

        <table class="table table-inner table-condensed">
            <tbody>
                <tr>
                    <th class="col-sm-2">Containing Latex?</th>
                    <th class="col-sm-4">Device labeled as not made with natural rubber latex?</th>
                    <th class="col-sm-2">Containing Phthalates?</th>
                    <th class="col-sm-4">MRI Safety Status</th>
                </tr>
                <tr>
                  <td [ngClass]="isDefault('Containing Latex?')">
                    <label controlName="containingLatex"> </label> </td>
                  <td [ngClass]="isDefault('Not made with natural rubber latex?')">
                    <label controlName="labeledAsNotMadeWithNaturalRubber"> </label> </td>
                  <td [ngClass]="isDefault('Containing Phthalates?')">
                    <label controlName="containingPhthalates"> </label> </td>
                  <td [ngClass]="isDefault('MRI Safety Status')">
                    <label controlName="mriSafetyStatus"> </label> </td>
                </tr>
            </tbody>
        </table>
        <table formArrayName="CMRForm" class="table table-inner table-condensed">
            <tbody>
                <tr>
                    <th class="col-sm-3">CMR or Endocrine Disrupting Substance Type</th>
                    <th class="col-sm-2">CAS Number</th>
                    <th class="col-sm-2">EC Number</th>
                    <th class="col-sm-2">Substance Name</th>
                    <th class="col-sm-2">Language</th>
                </tr>
                <ng-container *ngIf="CMRForm.controls.length; else emptyTemplate5fields">
                <tr formGroupName="{{i}}"
                    *ngFor="let substance of CMRForm.controls; let i = index">
                    <td
                    [ngClass]="isDefault('CMR')">
                    <label controlName="CMRValue"></label>
                    </td>
                    <td
                    [ngClass]="isDefault('CMR')">
                    <label controlName="casNumber"></label>
                    </td>
                    <td
                    [ngClass]="isDefault('CMR')">
                    <label controlName="ecNumber"></label>
                    </td>
                    <td  [ngClass]="isDefault('CMR')">
                        <table formArrayName="substanceNamesArray"
                            class="table table-inner table-condensed">
                            <tr formGroupName="{{i}}"
                                *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                                <td class="no-top-padding-inner-table" [ngClass]="isDefault('CMR')">
                                    <label controlName="value"></label>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td  [ngClass]="isDefault('CMR')">
                        <table formArrayName="substanceNamesArray"
                            class="table table-inner table-condensed">
                            <tr formGroupName="{{i}}"
                                *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                                <td class="no-top-padding-inner-table" [ngClass]="isDefault('CMR')">
                                    <label controlName="language"></label>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
              </ng-container>
            </tbody>
        </table>
        <table formArrayName="substancesForm" class="table table-inner table-condensed">
            <tbody>
                <tr>
                    <th class="col-sm-5">Medicinal or Medicinal Human Product Substance Type</th>
                    <th class="col-sm-2">INN Code</th>
                    <th class="col-sm-2">Substance Name</th>
                    <th class="col-sm-2">Language</th>
                </tr>
                <ng-container *ngIf="substancesForm.controls.length; else emptyTemplate4fields">
                <tr formGroupName="{{i}}"
                    *ngFor="let substance of substancesForm.controls; let i = index">
                    <td
                    [ngClass]="isDefault('MED Human Product Types')">
                        <label controlName="substanceType"></label>
                    </td>
                    <td
                    [ngClass]="isDefault('MED Human Product Types')">
                        <label controlName="innCode"></label>
                    </td>
                    <td
                    [ngClass]="isDefault('MED Human Product Types')">
                        <table formArrayName="substanceNamesArray"
                            class="table table-inner table-inline">
                            <tr formGroupName="{{i}}"
                                *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                                <td [ngClass]="isDefault('MED Human Product Types')">
                                    <label controlName="value"></label>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td
                    [ngClass]="isDefault('MED Human Product Types')">
                        <table formArrayName="substanceNamesArray"
                            class="table table-inner table-inline">
                            <tr formGroupName="{{i}}"
                                *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                                <td [ngClass]="isDefault('MED Human Product Types')">
                                    <label controlName="language"></label>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                </ng-container>
            </tbody>
        </table>
        <table formArrayName="criticalWarningForm" class="table table-inner table-condensed table-75">
            <tbody>
                <tr>
                    <th class="col-sm-4">Critical Warning or Contraindication Value(s)</th>
                    <th class="col-sm-4">Comments</th>
                    <th class="col-sm-4">Language</th>
                </tr>
                <ng-container *ngIf="criticalWarningForm.controls.length; else emptyTemplate3fields">
                <tr formGroupName="{{i}}"
                    *ngFor="let warning of criticalWarningForm.controls; let i = index">
                    <td
                    [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
                        <label controlName="warningValue"></label>
                    </td>
                    <td
                    [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
                        <table formArrayName="warningCommentsArray"
                            class="table table-inner table-inline">
                            <tr formGroupName="{{i}}"
                                *ngFor="let comment of warning.get('warningCommentsArray').controls; let i = index">
                                <td class="no-top-padding-inner-table" [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
                                    <label controlName="value"></label>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td
                    [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
                        <table formArrayName="warningCommentsArray"
                            class="table table-inner table-inline">
                            <tr formGroupName="{{i}}"
                                *ngFor="let comment of warning.get('warningCommentsArray').controls; let i = index">
                                <td class="no-top-padding-inner-table" [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
                                    <label controlName="language"></label>
                                </td>
                            </tr>
                        </table>
                    </td>
                 </tr>
                </ng-container>
             </tbody>
            </table>
            <table class="table table-inner table-condensed table-50">
              <tbody>
                  <tr>
                      <th>Critical Warnings and Contraindications</th>
                  </tr>
                  <tr>
                      <td [ngClass]="isDefault('Critical Warnings and Contraindications')">
                          <label  controlName="criticalWarningAndContraindication"> </label> </td>
                  </tr>
              </tbody>
          </table>
      </form>
  </div>
</div>
<ng-template #emptyTemplate3fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate5fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
